import { render, staticRenderFns } from "./SzabadsagKeres.vue?vue&type=template&id=06a0ea4e&scoped=true&"
import script from "./SzabadsagKeres.vue?vue&type=script&lang=js&"
export * from "./SzabadsagKeres.vue?vue&type=script&lang=js&"
import style0 from "./SzabadsagKeres.vue?vue&type=style&index=0&id=06a0ea4e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0ea4e",
  null
  
)

export default component.exports